const updateCollectionTitle = (url_params) => {
  const filters = url_params
    .replace("&filter.v.availability=1", "")
    .replace("?filter.v.availability=1", "")
    .split("&")
    .filter((el) => el.includes("filter"));
  let filterLabels = [];
  filters.forEach((el) => filterLabels.push(decodeURI(el.split("=")[1])));
  const title = document.querySelector(".js-collection-title");
  const metaTitle = document.querySelector("title");
  if (title == null) {
    return;
  }
  title.textContent = filterLabels.join(" ") + " " + title.dataset.title;

  if (metaTitle == null) {
    return;
  }
  metaTitle.textContent = filterLabels.join(" ") + " " + title.dataset.title;
};

const paginationControlers = () => {
  const paginationContainer = document.querySelector(".pagination");
  const prevButton = paginationContainer.querySelector(".prev");
  const nextButton = paginationContainer.querySelector(".next");
  if (prevButton != null) {
    prevButton.addEventListener("click", function (e) {
      e.preventDefault();
      window.location.href = prevButton.dataset.href;
    });
  }
  if (nextButton != null) {
    nextButton.addEventListener("click", function (e) {
      e.preventDefault();
      window.location.href = nextButton.dataset.href;
    });
  }
};
